var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4961_34822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 15.5424C32 27.6339 16 38 16 38C16 38 0 27.6339 0 15.5424C0 11.4258 1.68348 7.47229 4.6887 4.55131C7.68 1.6439 11.7565 0 16 0C20.2435 0 24.32 1.6439 27.3113 4.55131C30.3165 7.47229 32 11.4258 32 15.5424V15.5424Z",
    fill: "#FF7A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20.6776C19.281 20.6776 21.9408 18.0803 21.9408 14.8764C21.9408 11.6725 19.281 9.0752 16 9.0752C12.7189 9.0752 10.0591 11.6725 10.0591 14.8764C10.0591 18.0803 12.7189 20.6776 16 20.6776Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4961_34822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinMap);
export default __webpack_public_path__ + "static/media/PinMap.296b30b4a9587df112135bfc82226e4d.svg";
export { ForwardRef as ReactComponent };